import request from '../libs/request';

const res = 'RolePermission';

export default {
  update(roleID, clientType, permissionIDs) {
    return request({
      url: `api/${res}/updateRolePermissions`,
      method: 'post',
      data: {
        roleID,
        clientType,
        permissionIDs
      }
    });
  }
};
